import { NewsletterSignup } from '@/components/NewsletterSignup';
import { LabradorComponent } from '@/types/component';
import { getOcelotConfig } from 'lib/configs/ocelot';

export const LabradorNewsletterSignup: LabradorComponent = ({ type, data, meta }) => {
  if (!getOcelotConfig('features.newsletterSignup.enabled')) return null;

  const infoText = `
  Ja, jag samtycker och vill gärna få nyheter, marknadsföring, erbjudanden och inbjudningar till specialevenemang inom skönhet, mat, resor mm. via e-post eller sms från Aller Media AB. E-post och sms kan också innehålla nyheter, marknadsföring och erbjudanden från våra samarbetspartners. Vill du sluta få dessa e-post eller sms kan du trycka "Avregistrera" i nyhetsbrevet eller sms. För att få veta mer om hur Aller Media AB behandlar dina uppgifter kan du läsa vår <a target="_blank" href="https://www.aller.se/integritetspolicy/">integritetspolicy</a>.
  </br>
  </br>
  Notera att du som redan är kund/prenumerant hos Aller Media AB fortsatt kommer att få marknadsföringsutskick för våra produkter enligt våra <a target="_blank" href="https://www.aller.se/allmanna-villkor/">allmänna villkor</a> och <a target="_blank" href="https://www.aller.se/integritetspolicy/">integritetspolicy</a>.
  `;

  return (
    <NewsletterSignup
      headline={data.headline}
      description={infoText}
      footer={data.integrityText}
      successModal={{
        content: data.successText,
      }}
      submitButton={{
        content: data.submitLabel,
      }}
    />
  );
};
